import type { SyntheticEvent } from 'react';

/**
 * Simple event stopPropagation wrapper to test that it's called
 */
export const stopEventPropagation = (e: SyntheticEvent) => {
  e.stopPropagation();
};
